module.exports = __webpack_public_path__ + "img/guandai_xc4.1758b7d4.jpg";